import React, { useContext, useRef, useState } from 'react'
import './Navbar.css'
import Logo from '../Assets/logo.png'
import Cart_icon from '../Assets/cart_icon.png'
import { Link,  useNavigate } from 'react-router-dom'
import { ShopContext } from '../../Context/ShopContext'
import drop_down from '../Assets/chevron.png'

const Navbar = () => {
    const [menu, setmenu] = useState("shop")
    const navigate=useNavigate();
    const { get_total_cart_items } = useContext(ShopContext);
    const menu_ref=useRef();
    const drop_down_toggle=(e)=>{
        menu_ref.current.classList.toggle("nav-menu-visible");
        e.target.classList.toggle("open");
    }
    return (
        <>
            <div className='navbar'>
                <div className="nav-logo" onClick={()=>{
                    navigate("/");
                }} style={{cursor:"pointer"}}>
                    <img src={Logo} />
                    <p>CAPAZONE</p>
                </div>
                <img src={drop_down}  className='nav-dropdown' onClick={drop_down_toggle}/>
                <ul ref={menu_ref} className="nav-menu">
                    <li onClick={() => { setmenu("shop") }}><Link style={{ textDecoration: 'none', color: '#626262' }} to='/'>Shop</Link> {menu === "shop" ? <hr /> : <></>}</li>
                    <li onClick={() => { setmenu("men") }}><Link style={{ textDecoration: 'none', color: '#626262' }} to='/mens'>Men</Link>  {menu === "men" ? <hr /> : <></>}</li>
                    <li onClick={() => { setmenu("women") }}><Link style={{ textDecoration: 'none', color: '#626262' }} to='/womens'>Women</Link>  {menu === "women" ? <hr /> : <></>}</li>
                    <li onClick={() => { setmenu("kids") }}><Link style={{ textDecoration: 'none', color: '#626262' }} to='/kids'>Kid</Link>  {menu === "kids" ? <hr /> : <></>}</li>
                </ul>
                <div className="nav-login-cart">
                    {localStorage.getItem("auth-token")?<button onClick={()=>{localStorage.removeItem("auth-token");window.location.replace("/");}}>Logout</button>:<Link to="/login"><button>Login</button></Link>}
                    <Link to="/cart"><img src={Cart_icon} /></Link>
                    <div className="nav-cart-count">{get_total_cart_items()}</div>
                </div>
            </div>
        </>
    )
}

export default Navbar
